import type { ParticipantBehaviour } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaCaretDown, FaPencilAlt, FaRegTrashAlt } from 'react-icons/fa';
import { showModal } from '../../../components/generic/Modal';
import { ParticipantBehaviourDeleteModal } from './ParticipantBehaviourDeleteModal';
import { ParticipantBehaviourEditModal } from './ParticipantBehaviourEditModal';

interface Props extends ChakraV3.ButtonProps {
  participantId: string;
  participantBehaviour: ParticipantBehaviour;
  isDisabled?: boolean;
}

export const ParticipantBehaviourActionMenu = (props: Props) => {
  const { participantId, participantBehaviour, isDisabled, ...rest } = props;

  return (
    <ChakraV3.Menu.Root lazyMount={true} unmountOnExit={false}>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button disabled={isDisabled} variant='plain' size='sm' {...rest}>
          Actions
          <FaCaretDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(ParticipantBehaviourEditModal, {
                participantId,
                participantBehaviour,
              })
            }
            disabled={isDisabled}
            value='edit'
          >
            <FaPencilAlt />
            Edit
          </ChakraV3.MenuItem>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(ParticipantBehaviourDeleteModal, {
                participantId,
                participantBehaviourId: participantBehaviour.id,
                participantBehaviourName: participantBehaviour.name,
              })
            }
            value='delete'
            color='danger'
            disabled={isDisabled}
          >
            <FaRegTrashAlt />
            Delete
          </ChakraV3.MenuItem>
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
    </ChakraV3.Menu.Root>
  );
};
